import { Navigate, useLocation } from 'react-router-dom';

/** Legacy flyer URL. Keep query so old UTM codes still attribute. */
export default function AlpenbrevetCampaign() {
  const location = useLocation();
  return <Navigate to={{ pathname: '/eroica', search: location.search }} replace />;
}
